
    import './styles.scoped.css';
    export default {
  "input-adorned-container": "awsui_input-adorned-container_2rhyz_14keo_9",
  "input": "awsui_input_2rhyz_14keo_9",
  "input-adorned-container-readonly": "awsui_input-adorned-container-readonly_2rhyz_14keo_22",
  "input-readonly": "awsui_input-readonly_2rhyz_14keo_22",
  "root": "awsui_root_2rhyz_14keo_37",
  "input-invalid": "awsui_input-invalid_2rhyz_14keo_140",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_14keo_149",
  "input-warning": "awsui_input-warning_2rhyz_14keo_152",
  "input-type-search": "awsui_input-type-search_2rhyz_14keo_164",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_14keo_177",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_14keo_180",
  "grouped": "awsui_grouped_2rhyz_14keo_187",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_14keo_193",
  "grouped-in-validation": "awsui_grouped-in-validation_2rhyz_14keo_200",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_14keo_214",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_14keo_234",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_14keo_255",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_14keo_277",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_14keo_298",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_14keo_318",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_14keo_339",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_14keo_361",
  "grouped-validation": "awsui_grouped-validation_2rhyz_14keo_365",
  "input-container": "awsui_input-container_2rhyz_14keo_370",
  "input-icon-start": "awsui_input-icon-start_2rhyz_14keo_375",
  "input-icon-end": "awsui_input-icon-end_2rhyz_14keo_382",
  "input-button-right": "awsui_input-button-right_2rhyz_14keo_388",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_14keo_392",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_14keo_395",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_14keo_399",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_14keo_402",
  "inline-label": "awsui_inline-label_2rhyz_14keo_392",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_14keo_427",
  "input-adorned-container-disabled": "awsui_input-adorned-container-disabled_2rhyz_14keo_452",
  "input-adorned-container-invalid": "awsui_input-adorned-container-invalid_2rhyz_14keo_460",
  "input-adorned-container-warning": "awsui_input-adorned-container-warning_2rhyz_14keo_473",
  "input-prefix": "awsui_input-prefix_2rhyz_14keo_487",
  "input-suffix": "awsui_input-suffix_2rhyz_14keo_488",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_14keo_501",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_14keo_510",
  "input-adorned": "awsui_input-adorned_2rhyz_14keo_9"
};
  